<template>
  <div>
    <v-row v-if="user">
      <v-col>
        <AvatarWithBadge :user="user" />
      </v-col>
    </v-row>
    <v-row v-else class="text-center">
      <v-col>
        <v-skeleton-loader type="avatar" class="mx-auto" />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col v-if="user && user.userProfile && user.userProfile.username">
        @{{ user.userProfile.username }}</v-col
      >
    </v-row>
    <v-divider class="my-5"></v-divider>
    <v-row no-gutters>
      <v-col>
        <v-list dense nav class="pa-0">
          <v-list-item :to="{name: 'user-settings-account-info'}" class="rounded-0 text-left">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("userSettings.accountInfo")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AvatarWithBadge from "@/components/User/AvatarWithBadge";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
export default {
  name: "UserSettingsSidebar",
  mixins: [hasLoggedInUser],
  components: {
    AvatarWithBadge
  },
}
</script>
<style scoped lang="scss">
::v-deep .v-skeleton-loader__avatar {
  margin: 0 auto;
}

</style>